import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
  const locales = window["appSettings"]["locales"];
  const messages: LocaleMessages = {}

  Object.keys(locales).forEach(key => {
    messages[key] = window["appSettings"]["locales"][key]
  })

  return messages
}

export default new VueI18n({
  locale: 'he',
  fallbackLocale: 'en',
  silentTranslationWarn: false,
  messages: loadLocaleMessages(),
});
